import React from 'react'
import { FiSettings } from "react-icons/fi";
import { GoPlus } from "react-icons/go";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import OwnershipTypesTable from './ownership-types-table/OwnershipTypesTable';
import { Pagination } from 'antd';

const OwnershipTypes = ({ data, handleDelete, onChangeVal, initialVlue, handleChange, ownershipData, reset }) => {
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>Ownership Types</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-ownership-type" className="btn btn-success">
              <GoPlus /> Add New Ownership Types
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <OwnershipTypesTable data={data} handleDelete={handleDelete} initialVlue={initialVlue} handleChange={handleChange} ownershipData={ownershipData} reset={reset} />
        </div>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCount} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCount}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OwnershipTypes